module.exports = __webpack_public_path__ + "images/gavdos/routes/RET-GVD-RET-inactive@2x.png";